"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponents = void 0;
var index_1 = require("./index");
function getComponents(overrides, defaultComponents) {
    return index_1.merge({}, defaultComponents, overrides);
}
exports.getComponents = getComponents;
//# sourceMappingURL=overrides.js.map